import React from 'react';
import * as PropTypes from 'prop-types';

import { MAYO_CLINIC_URL } from '../../constants';
import styles from '../index.styl';

export const SaturationInfoForm = ({ formatMessage }) => {
  const handleOpenOuterLink = () => {
    window.open(MAYO_CLINIC_URL, '_blank');
  };

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        {formatMessage({ id: 'patient.healthboard.saturation.info' })}
      </div>
      <div className={styles.content}>
        <div className={styles.description}>
          {formatMessage({ id: 'patient.healthboard.saturation.description' })}
        </div>
        <div className={styles.clinicDescriptionWrapper}>
          <span className={styles.clinicDescription}>
            {formatMessage({ id: 'patient.healthboard.saturation.mayoClinic' })}
          </span>
          <span className={styles.redirectLink} onClick={handleOpenOuterLink}>
            {formatMessage({
              id: 'patient.healthboard.saturation.mayoClinicTitle',
            })}
          </span>
        </div>
      </div>
    </div>
  );
};

SaturationInfoForm.propTypes = {
  formatMessage: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/Forms/SaturationInfoForm/index.jsx